import React from 'react';
import PermissionClassificationDataTable from './PermissionClassificationDataTable';

const PermissionClassificationIndex = ({ moreData, setMoreData }) => {
  return (
    <>
      <PermissionClassificationDataTable moreData={moreData} setMoreData={setMoreData} />
    </>
  );
};

export default PermissionClassificationIndex;
